import { SessionActions } from './../../user/auth/auth.actions';
import { Action, createReducer, on } from '@ngrx/store';
import { getWebsiteMainAnalyticsActions } from './website-analytics.actions';

export interface WebsiteAnalyticsState {
  analytics: any;
  // {
  //   aggregateAnalytics: { results: any },
  //   bestCountry: { results: { country: string, visitors: number }[] },
  //   realtimeVisitors: number
  // };
  analyticsLoaded: boolean;
  analyticsError: any;
  period: any;
}

const initialState: WebsiteAnalyticsState = {
  analytics: null,
  analyticsLoaded: false,
  analyticsError: null,
  period: null,
};

export const websiteAnalyticsReducer = createReducer(
  initialState, // Analytics
  on(getWebsiteMainAnalyticsActions.load, (state, { period, silent }) => ({
    ...state,
    analyticsLoaded: silent ? state.analyticsLoaded : false,
    analyticsError: null,
    period: period || state.period,
  })),
  on(getWebsiteMainAnalyticsActions.loadSuccess, (state, { stats }) => ({
    ...state,
    analytics: { ...state.analytics, ...stats },
    analyticsLoaded: true,
  })),

  on(getWebsiteMainAnalyticsActions.loadFailure, (state, { error }) => ({
    ...state,
    analyticsError: error,
  })),

  on(SessionActions.forget, (state) => initialState),
);
